'use client';

import EligibilityGatedLink from 'components/EligibilityGatedLink';
import CaretIcon from 'components/icons/CaretIcon';
import { captureConversationStarted } from 'lib/analytics';

const benefits = [
  {
    number: '1',
    title: 'A Guided Experience',
    description:
      'ALEX will walk you through enrollment step-by-step. No guessing about what to do next.',
  },
  {
    number: '2',
    title: 'A Recommendation Tailored to You',
    description:
      'ALEX gets to know your needs, priorities, prescriptions, and providers, all while estimating costs based on where you live, so your recommendation is fine-tuned to your life.',
  },
  {
    number: '3',
    title: 'Enroll Confidently',
    description:
      'ALEX makes sure you understand the whats and whys of Medicare coverage, along with your options, so you can trust in your decision.',
  },
];

const HumanaBenefits: React.FC = () => {
  return (
    <section className="benefits-section blue-gradient">
      <div className="benefits-layout">
        <div className="left-column">
          <h2 className="benefits-heading">
            Learn, choose, and enroll in Medicare coverage.
          </h2>
          <EligibilityGatedLink
            href="/check-audio"
            gtmEvent="GetStartedClick"
            onClick={() => captureConversationStarted('humana_benefits')}
          >
            <button className="button primary">
              Help me understand my options
              <CaretIcon direction="right" size="large" color="white" />
            </button>
          </EligibilityGatedLink>
        </div>
        <div className="right-column">
          <ul>
            {benefits.map(({ number, title, description }) => (
              <li className="benefit-item" key={number}>
                <div className="benefit-number">{number}</div>
                <div className="benefit-content">
                  <h3>{title}</h3>
                  <p className="benefit-description">{description}</p>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default HumanaBenefits;
